import { CacheLookupPolicy } from '@azure/msal-browser';
import type { Configuration, PopupRequest, SilentRequest } from '@azure/msal-browser';

import { TENANTS, type TenantCode } from './tenants';

// Minimalistische MSAL config: alleen wat strikt nodig is, opgebouwd per
// tenant uit de registry. localStorage zodat de sessie over tabs heen bekend
// is — met sessionStorage start elke nieuwe tab (target="_blank", gedeelde
// link) met een lege tokencache en belandt de gebruiker op /login. De
// tijdelijke auth-flow state blijft wel per tab (temporaryCacheLocation staat
// standaard op sessionStorage).
export function buildMsalConfig(code: TenantCode): Configuration {
  const tenant = TENANTS[code];
  return {
    auth: {
      clientId: tenant.clientId,
      authority: tenant.authority,
      redirectUri: tenant.redirectUri,
    },
    cache: {
      cacheLocation: 'localStorage',
    },
  };
}

// openid + profile: minimaal voor sign-in en account.name (UserBadge).
// MSAL voegt zelf offline_access toe als OIDC default — dat is een MSAL
// library-eigenschap tegen Microsoft authorities en niet vanuit de SPA te
// onderdrukken zonder off-label gebruik. Het admin-consent scherm reflecteert
// de App Registration's declared permissions, niet runtime scopes.
export const loginRequest: PopupRequest = {
  scopes: ['openid', 'profile'],
};

// Stil vernieuwen, maar zonder MSAL's laatste redmiddel: het verborgen iframe
// naar login.microsoftonline.com. Dat leunt op een third-party cookie, en die
// blokkeren Safari en Firefox al standaard — het zou dus per browser anders
// werken, en het kost zes seconden wachten voordat het opgeeft. Met deze policy
// (niet opgenomen in MSAL's iFrameRenewalPolicies) blijft over: geldig token uit
// de cache, anders de refresh token inwisselen. Lukt dat niet, dan is de sessie
// voorbij en logt de gebruiker één keer opnieuw in — in elke browser hetzelfde.
export const silentRequest: SilentRequest = {
  ...loginRequest,
  cacheLookupPolicy: CacheLookupPolicy.AccessTokenAndRefreshToken,
};
